import { Component, ViewEncapsulation } from '@angular/core';
import { authRequestNavigation } from '@mi-tool/navigation/auth-request-navigation';
import { teamNavigation, userProfileNavigation } from '@mi-tool/navigation/profile-navigation';
import {
  assetsNavigation,
  hcAdminNavigation,
  userAdminNavigation,
  userAdminSyncNavigation,
} from '@mi-tool/navigation/user-admin-navigation';
import { Helpers } from '../../utils/helpers';
import { AuthService, PermissionHandler } from 'app/auth/auth.service';

@Component({
  selector: 'medis-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MedisNavigationComponent {
  isInquiriesView: boolean;
  isDocumentsView: boolean;
  navigation = [];

  private permissions: PermissionHandler;
  private routerUrl: Helpers.View;

  constructor(private _helpers: Helpers, private authService: AuthService) {
    this.authService.permissions.subscribe((handler) => {
      this.permissions = handler;
      this.updateNavigation();
    });

    this._helpers.layoutDependsOnRouterEvent$$.subscribe((routerUrl) => {
      this.routerUrl = routerUrl;
      this.updateNavigation();
    });
  }

  private updateNavigation(): void {
    if (this.routerUrl) {
      this.isInquiriesView = this.routerUrl === 'inquiriesView';
      this.isDocumentsView = this.routerUrl === 'documentsView';
      if (this.routerUrl === 'userProfileView' || this.routerUrl === 'userProfileAdminView') {
        this.navigation = userProfileNavigation(this.permissions);
      } else if (this.routerUrl === 'teamsView') {
        this.navigation = teamNavigation(this.permissions);
      } else if (this.routerUrl === 'authRequestsView') {
        this.navigation = authRequestNavigation(this.permissions);
      } else if (this.routerUrl === 'userAdminView') {
        this.navigation = userAdminNavigation(this.permissions);
      } else if (this.routerUrl === 'hcpAdministration') {
        this.navigation = hcAdminNavigation(this.permissions);
      } else if (this.routerUrl === 'userSyncView') {
        this.navigation = userAdminSyncNavigation(this.permissions);
      } else if (this.routerUrl === 'assetsView') {
        this.navigation = assetsNavigation(this.permissions);
      } else {
        this.navigation = [];
      }
    }
  }
}
